<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useCartStore } from '@/composables/stores';
import { useFormat } from '@/composables/useFormat';

const cart = useCartStore();
const router = useRouter();
const { t } = useI18n();
const { money } = useFormat();

function goToCart() {
  router.push('/cart');
}
</script>

<template>
  <button v-if="cart.itemCount > 0" type="button" class="cart-float" @click="goToCart" :aria-label="t('cart.viewCart')">
    <span class="count">{{ cart.itemCount }}</span>
    <span class="label">{{ t('cart.viewCart') }}</span>
    <strong class="total">{{ money(cart.summary.total) }}</strong>
  </button>
</template>

<style scoped>
.cart-float {
  position: fixed;
  bottom: 96px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 480px;
  background: var(--brand-blue);
  color: #fff;
  border-radius: var(--radius);
  padding: 12px 16px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: center;
  box-shadow: var(--shadow-lg);
  z-index: 35;
  transition: transform var(--t), box-shadow var(--t);
}
.cart-float:hover { transform: translateX(-50%) translateY(-2px); }
.count {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 10px;
  border-radius: var(--radius-pill);
  font-weight: 800;
}
.label { font-weight: 700; }
.total { font-weight: 800; font-size: 16px; }
</style>
